import { USRCREATE_URLS } from '../../config/config'
import { UserAPICall } from './UserRequestUtil'


export const UserCreate = async (type,param) => {
  const url = USRCREATE_URLS[type];

  const parameter = {
    username: param.uid,
    attributes: crateAttribute(type,param)
  };

  const res = await UserAPICall(url,parameter);


  return res;
}

const crateAttribute = (type,params) => {
  const result =
  [
    {
      "Name": "email",
      "Value": params.email
    },
    {
      "Name": "family_name",
      "Value": params.familyname
    },
    {
      "Name": "given_name",
      "Value": params.lastname
    },
  ]

  if(type != "product"){
    result.push({
      "Name": "custom:tenant",
      "Value": params.tenantname
    })
  }

  return result;
};
